import * as PatientBannerActions from '../../PatientFolder/PatientBanner/actions.js'

import * as PatientActions from './actions.js'

// define initial state of all possible properties
export const initialState = {
  clientName: null,
  error: false,
  loading: false,
  patientModalOpen: false,
  patient: {},
  previousPatient: {},
  episodeOfCare: {},
  creating: false,
  updating: false
}

export default function reducer (state = initialState, action) {
  // modify state based on action types
  switch (action.type) {
    case PatientBannerActions.PATIENT_BANNER_SUCCESS:
      return {
        ...initialState,
        previousPatient: { ...(action.patient ?? {}) },
        patient: { ...(action.patient ?? {}) },
        episodeOfCare: { ...(action.episodeOfCare ?? {}) },
        updating: true
      }
    case PatientActions.PATIENT_CREATE:
      return {
        ...initialState,
        loading: true
      }
    case PatientActions.PATIENT_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        savedPatient: action.savedPatient
      }
    case PatientActions.PATIENT_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case PatientActions.PATIENT_UPDATE:
      return {
        ...state,
        loading: true,
        updatedPatient: null
      }
    case PatientActions.PATIENT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updatedPatient: action.savedPatient
      }
    case PatientActions.PATIENT_UPDATE_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }

    case PatientActions.PATIENT_MODAL_CLIENTNAME_UPDATE:
      return {
        ...state,
        clientName: action.clientName
      }

    case PatientActions.PATIENT_OPEN_MODAL: {
      return {
        ...state,
        patientModalOpen: true
      }
    }
    case PatientActions.PATIENT_RESET_FORM: {
      if (state.creating) {
        return { ...initialState }
      }
      return {
        ...initialState,
        previousPatient: state.previousPatient,
        patient: { ...state.previousPatient },
        updating: true
      }
    }

    default:
      return state
  }
}
